var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245.527,
    height: 72.641,
    viewBox: "0 0 245.527 72.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7580",
    x: 49.354,
    y: 9.476,
    width: 45.489,
    height: 50.486,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7581",
    x: 79.041,
    y: 7.428,
    width: 37.742,
    height: 51.635,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7582",
    x: 101.132,
    y: 22.07,
    width: 37.742,
    height: 37.793,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7583",
    x: 123.221,
    y: 22.921,
    width: 37.593,
    height: 36.942,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7584",
    x: 145.311,
    y: 6.678,
    width: 31.045,
    height: 52.385,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7585",
    x: 159.406,
    y: 6.678,
    width: 31.045,
    height: 52.385,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7586",
    x: 173.5,
    y: 22.07,
    width: 37.742,
    height: 37.793,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7587",
    x: 195.59,
    y: 22.921,
    width: 37.593,
    height: 36.942,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7588",
    x: 217.68,
    y: 22.07,
    width: 27.846,
    height: 36.993,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7589",
    x: 0,
    y: 21.409,
    width: 49.835,
    height: 51.231,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23582",
    "data-name": "Group 23582",
    transform: "translate(362.914 -214.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23580",
    "data-name": "Group 23580",
    transform: "translate(-304.56 227.078)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7580-2",
    "data-name": "Path 7580",
    d: "M-299.047,251.756a13.538,13.538,0,0,0,3.5,9.154A12,12,0,0,0-286,264.926a13.4,13.4,0,0,0,4.772-.9,11.876,11.876,0,0,0,4.224-2.75l2.3,2.2a17.47,17.47,0,0,1-5.223,3.373A15.565,15.565,0,0,1-286,268.074a15.53,15.53,0,0,1-11.445-4.79,15.785,15.785,0,0,1-4.749-11.529,15.557,15.557,0,0,1,4.749-11.426A15.608,15.608,0,0,1-286,235.588a15.821,15.821,0,0,1,6.1,1.175,16.655,16.655,0,0,1,5.2,3.424l-2.3,2.2a11.957,11.957,0,0,0-4.173-2.748,13.24,13.24,0,0,0-4.822-.9,12.078,12.078,0,0,0-9.546,3.966A13.3,13.3,0,0,0-299.047,251.756Z",
    transform: "translate(360.55 -220.11)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7581-2",
    "data-name": "Path 7581",
    d: "M-240.641,257.242v9.1h-3.148v-9.125a6.493,6.493,0,0,0-1.95-4.763,6.513,6.513,0,0,0-4.8-1.955,6.453,6.453,0,0,0-4.748,1.955,6.5,6.5,0,0,0-1.949,4.763v9.125h-3.149V232.7h3.149v17.342a9.423,9.423,0,0,1,6.7-2.7,9.538,9.538,0,0,1,7,2.9A9.538,9.538,0,0,1-240.641,257.242Z",
    transform: "translate(348.42 -219.28)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7582-2",
    "data-name": "Path 7582",
    d: "M-212.676,270.47a9.869,9.869,0,0,1-3.1,1.973,9.772,9.772,0,0,1-3.648.676,9.474,9.474,0,0,1-6.947-2.9,9.532,9.532,0,0,1-2.9-7,9.6,9.6,0,0,1,2.874-6.972,9.41,9.41,0,0,1,6.972-2.925,9.392,9.392,0,0,1,6.748,2.75v-1.9h3.148v18.142h-3.148Zm-6.748-13.994a6.447,6.447,0,0,0-4.748,1.958,6.493,6.493,0,0,0-1.949,4.764,6.607,6.607,0,0,0,1.949,4.766,6.37,6.37,0,0,0,4.748,2.006,6.508,6.508,0,0,0,4.8-1.955,6.559,6.559,0,0,0,1.95-4.817,6.491,6.491,0,0,0-1.95-4.764A6.507,6.507,0,0,0-219.424,256.476Z",
    transform: "translate(339.4 -225.26)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7583-2",
    "data-name": "Path 7583",
    d: "M-188.462,273.466a9.251,9.251,0,0,1-6.822-2.915,9.562,9.562,0,0,1-2.875-6.956v-9.071h3.15v9.067a6.538,6.538,0,0,0,1.948,4.732,6.219,6.219,0,0,0,4.6,1.993,6.534,6.534,0,0,0,4.8-1.943,6.486,6.486,0,0,0,1.948-4.783v-9.067h3.15V263.6a9.5,9.5,0,0,1-2.9,6.979A9.548,9.548,0,0,1-188.462,273.466Z",
    transform: "translate(330.38 -225.6)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7584-2",
    "data-name": "Path 7584",
    d: "M-154,231.647V234.8a6.573,6.573,0,0,0-4.749,1.95,6.382,6.382,0,0,0-2,4.748v6.347h3.2v3.15h-3.2v15.043H-163.9V250.989h-3.15v-3.15h3.15v-6.347a9.481,9.481,0,0,1,2.9-6.948A9.537,9.537,0,0,1-154,231.647Z",
    transform: "translate(321.36 -218.97)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7585-2",
    "data-name": "Path 7585",
    d: "M-134.149,231.647V234.8a6.569,6.569,0,0,0-4.749,1.95,6.375,6.375,0,0,0-2,4.748v6.347h3.2v3.15h-3.2v15.043h-3.15V250.989h-3.148v-3.15h3.148v-6.347a9.474,9.474,0,0,1,2.9-6.948A9.53,9.53,0,0,1-134.149,231.647Z",
    transform: "translate(315.6 -218.97)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7586-2",
    "data-name": "Path 7586",
    d: "M-123.994,264.772a6.773,6.773,0,0,0,2.322,3.734,6.354,6.354,0,0,0,4.173,1.463,6.607,6.607,0,0,0,2.424-.437,6.032,6.032,0,0,0,2.025-1.311l2.3,2.249a9.886,9.886,0,0,1-3.1,1.973,9.778,9.778,0,0,1-3.649.676,9.472,9.472,0,0,1-6.947-2.9,9.53,9.53,0,0,1-2.9-7,9.6,9.6,0,0,1,2.874-6.972,9.411,9.411,0,0,1,6.972-2.925,9.553,9.553,0,0,1,7,2.887,9.477,9.477,0,0,1,2.9,6.967v1.593Zm0-3.148h13.044a6.615,6.615,0,0,0-2.349-3.71,6.527,6.527,0,0,0-4.2-1.438,6.521,6.521,0,0,0-4.148,1.463A6.366,6.366,0,0,0-123.994,261.624Z",
    transform: "translate(309.84 -225.26)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7587-2",
    "data-name": "Path 7587",
    d: "M-86.535,273.466a9.251,9.251,0,0,1-6.822-2.915,9.567,9.567,0,0,1-2.874-6.956v-9.071h3.15v9.067a6.538,6.538,0,0,0,1.948,4.732,6.219,6.219,0,0,0,4.6,1.993,6.534,6.534,0,0,0,4.8-1.943,6.486,6.486,0,0,0,1.948-4.783v-9.067h3.15V263.6a9.5,9.5,0,0,1-2.9,6.979A9.548,9.548,0,0,1-86.535,273.466Z",
    transform: "translate(300.82 -225.6)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.35, -12.68)",
    filter: "url(#Path_7588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7588-2",
    "data-name": "Path 7588",
    d: "M-55.273,253.326v3.15a6.453,6.453,0,0,0-4.749,1.955,6.5,6.5,0,0,0-1.95,4.763v9.125h-3.148V254.177h3.148v1.9A9.334,9.334,0,0,1-55.273,253.326Z",
    transform: "translate(291.8 -225.26)",
    fill: "#6e2a73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23581",
    "data-name": "Group 23581",
    transform: "translate(-358.387 214.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.53, 0)",
    filter: "url(#Path_7589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7589-2",
    "data-name": "Path 7589",
    d: "M-371.654,251.4a15.824,15.824,0,0,0-1.61,6.943c0,8.791,15.917,26.288,15.917,26.288s15.918-17.5,15.918-26.288a15.825,15.825,0,0,0-1.611-6.943,43.126,43.126,0,0,1-14.307,2.144A43.127,43.127,0,0,1-371.654,251.4Zm19.158,8.892a4.851,4.851,0,0,1-4.851,4.851,4.851,4.851,0,0,1-4.851-4.851,4.851,4.851,0,0,1,4.851-4.851A4.851,4.851,0,0,1-352.5,260.289Z",
    transform: "translate(382.26 -223.99)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    "data-name": "Path 7590",
    d: "M-374.571,227.794l.957-.353a43.163,43.163,0,0,1,14.352-2.147,43.167,43.167,0,0,1,14.352,2.147l.957.353.334.963.377,1.089c2.339-1.611,4.205-3.431,4.371-5.99-.225-3.462-3.556-5.574-6.966-7.641-3.632-1.942-7.344-3.837-13.425-3.964-6.082.127-9.793,2.023-13.425,3.964-3.411,2.067-6.741,4.179-6.965,7.641.166,2.559,2.033,4.379,4.371,5.99l.377-1.088Z",
    transform: "translate(379.653 -212.251)",
    fill: "#6e2a73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7591",
    "data-name": "Path 7591",
    d: "M-373.443,243.005c3.123,1.879,9.135,3.151,16.043,3.151s12.92-1.273,16.043-3.151l-2.437-7.033a41.261,41.261,0,0,0-13.606-2.014,41.267,41.267,0,0,0-13.606,2.014Z",
    transform: "translate(377.791 -218.759)",
    fill: "#6e2a73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a040e275ea7ecee63ae1311c02bfa8cc.svg";
export { ForwardRef as ReactComponent };